export function formatBaseUnits(value: string, decimals = 6): string {
  if (!/^-?\d+$/.test(value) || !Number.isSafeInteger(decimals) || decimals < 0) return value;
  const amount = BigInt(value);
  const negative = amount < 0n;
  const absolute = negative ? -amount : amount;
  const scale = 10n ** BigInt(decimals);
  const whole = absolute / scale;
  const fraction = (absolute % scale).toString().padStart(decimals, "0").replace(/0+$/, "");
  return `${negative ? "-" : ""}${whole.toLocaleString()}${fraction ? `.${fraction}` : ""}`;
}
